var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondFirstLedgerAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 141,
    viewBox: "0 0 139 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First Ledger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_18493)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0374,
    cy: 30.232,
    rx: 30.0374,
    ry: 30.232,
    transform: "matrix(0.981701 0.190431 -0.15826 0.987398 44.5703 35)",
    fill: "#7600FC",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_18493)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0374,
    cy: 30.232,
    rx: 30.0374,
    ry: 30.232,
    transform: "matrix(0.981701 0.190431 -0.15826 0.987398 44.5703 35)",
    fill: "#7600FC",
    fillOpacity: 0.82
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.8906 46.9805L92.0007 54.5671L85.6549 94.1589L46.5449 86.5723L52.8906 46.9805ZM71.6141 73.9428C69.9211 73.6144 68.3838 73.3726 66.8742 72.9912C66.3097 72.8371 65.8054 72.4999 65.4387 72.0316C63.5655 69.4398 61.7747 66.7969 59.9385 64.1721C59.682 63.8059 59.3927 63.4628 59.0438 63.0117L56.3734 79.6723L78.6002 83.9839L82.2068 61.4819L65.6934 58.2786C66.0784 58.8681 66.3291 59.2707 66.5955 59.6576C68.3659 62.2134 70.1572 64.7545 71.8947 67.3334C72.2199 67.7893 72.3918 68.3371 72.3838 68.8924C72.2186 70.5016 71.9049 72.0953 71.6093 73.9392L71.6141 73.9428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_18493",
    x: 0.094532,
    y: 0.871876,
    width: 138.358,
    height: 139.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18493"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_18493",
    x: 0.094532,
    y: 0.871876,
    width: 138.358,
    height: 139.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondFirstLedgerAdaptiveIcon);
export default __webpack_public_path__ + "static/media/SecondFirstLedgerAdaptiveIcon.0e97719530b22e4edab3d6062b8f5884.svg";
export { ForwardRef as ReactComponent };